import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { convertLegacyEntityCardExtension } from '@backstage/plugin-catalog-react/alpha';
import {
  EntityAmazonEcrImagesContent,
  isAmazonEcrAvailable,
} from '@aws/amazon-ecr-plugin-for-backstage';

/**
 * Amazon ECR entity card. Same legacy bridge as aws-ecs — see that module's
 * header comment and docs/operations.md → "AWS Labs plugin suite".
 */
const awsEcrEntityCard = convertLegacyEntityCardExtension(
  EntityAmazonEcrImagesContent,
  {
    name: 'aws-ecr',
    filter: isAmazonEcrAvailable,
  },
);

export const awsEcrModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [awsEcrEntityCard],
});
